'use client';
import { InitialData } from '@/app/lib/schemas/types/app-types';
import { closeDrawer } from '@/app/lib/store/drawer-slice';
import { useAppDispatch } from '@/app/lib/store/hooks';
import { setBranches } from '@/app/lib/store/navigation-slice';
import { setScrollState } from '@/app/lib/store/scroll-slice';
import { setTheme } from '@/app/lib/store/theme-slice';
import { setUser } from '@/app/lib/store/user-slice';
import { useEffect, useState } from 'react';

interface Props {
  initialData: InitialData;
}

export default function DataDispatcher({ initialData }: Props) {
  const { themeMode, user, branchesForNav } = initialData;

  const dispatch = useAppDispatch();

  const container = document.getElementById('content-container');

  useEffect(() => {
    dispatch(setTheme(themeMode));
    console.log('user dispatched ', user);
    dispatch(setUser(user));
    dispatch(setBranches(branchesForNav));
    dispatch(closeDrawer());
  }, [dispatch, themeMode, user, branchesForNav]);

  //Предотвращаем проблему с гидратацией
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (isClient && container) {
      const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = container;
        const isAtTop = scrollTop < 50;
        const isAtBottom = scrollHeight - scrollTop <= clientHeight + 50; // Добавляем 50px запаса

        dispatch(setScrollState({ isAtTop, isAtBottom, scrollTop }));
      };

      if (container) {
        container.addEventListener('scroll', handleScroll);
      }

      return () => {
        if (container) {
          container.removeEventListener('scroll', handleScroll);
        }
      };
    }
  }, [dispatch, isClient, container]);

  return null;
}
